import apiClient from "./apiClient";

export const STATION_UPDATE_SUPPORTED = true;

export const getStations = async (params = {}) => {
  const response = await apiClient.get("/api/stations", { params });
  return response.data?.stations || response.data?.data || response.data || [];
};

export const getStationById = async (stationId) => {
  const response = await apiClient.get(`/api/stations/${stationId}`);
  return response.data?.station || response.data?.data || response.data || null;
};

export const createStation = async (payload) => {
  const response = await apiClient.post("/api/stations", payload);
  return response.data;
};

export const updateStation = async (stationId, payload) => {
  const response = await apiClient.put(`/api/stations/${stationId}`, payload);
  return response.data;
};
